import { render } from "./MiniProduct.vue?vue&type=template&id=5320cb0e&scoped=true"
import script from "./MiniProduct.vue?vue&type=script&lang=js"
export * from "./MiniProduct.vue?vue&type=script&lang=js"

import "./MiniProduct.vue?vue&type=style&index=0&id=5320cb0e&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5320cb0e"]])

export default __exports__